import { useDogxContext } from "@libs/dogx";
import acInterceptor from "../acInterceptor";
import { transformTrackPayload } from "./transformPayload";
import type {
	SortingDebtInvalidateCacheProps,
	SortingDebtReqProps,
	SortingDebtResponse,
} from "./types";

const headers = {
	"Content-Type": "application/json;charset=UTF-8",
	"Access-Control-Allow-Origin": "*",
};

const useApiSortingDebt = () => {
	const baseURL = import.meta.env.VITE_NEW_SORTING_DEBT_API_URL;
	const { getExperimentVariant } = useDogxContext();
	const experimentVariant = getExperimentVariant("dx-smart-cj");

	const apiSortingDebtTrack = {
		send: (payload: SortingDebtReqProps) => {
			const safePayload = payload || {};

			if (experimentVariant !== "control") {
				safePayload.parameters = {
					variant: "restricted-journey",
				};
			}

			return acInterceptor({ baseURL }).Post<SortingDebtResponse>(
				"/sorting-debt/v1/app/debt/track",
				transformTrackPayload(safePayload),
				{
					headers: headers,
				},
			);
		},
	};

	const apiSortingDebtInvalidateCache = {
		send: (payload: SortingDebtInvalidateCacheProps) =>
			acInterceptor({ baseURL }).Post<SortingDebtResponse>(
				"/sorting-debt/v1/public/debt/invalidate",
				payload,
				{
					headers: headers,
				},
			),
	};

	return { apiSortingDebtTrack, apiSortingDebtInvalidateCache };
};

export default useApiSortingDebt;
